import React from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { ResearchSection } from '../components/ResearchSection';
import { ValuesSection } from '../components/ValuesSection';
import { QualificationSection } from '../components/QualificationSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';

export const HomePage = () => {
  return (
    <>
      <Navigation />

      <main>
        <Hero />
        <ResearchSection />
        <ValuesSection />
        <QualificationSection />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
};

export default HomePage;
